import DateFnsUtils from '@date-io/date-fns'
import { format as fnsFormat } from 'date-fns'
import ja from 'date-fns/locale/ja'

export function timeFormat(time: string | Date) {
  const options = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  } as const

  const format = new Intl.DateTimeFormat('ja-JP', options)
  const date = time instanceof Date ? time : new Date(time)
  return format.format(date)
}

export function timeWithoutYear(timeStr: string) {
  return fnsFormat(new Date(timeStr), 'MM/dd HH:mm')
}

export function dateFormat(date: number | Date) {
  return fnsFormat(date, 'yyyy-MM-dd')
}

export function stringLength(filename: string): number {
  if (!filename) return 0
  const segmenter = new Intl.Segmenter('en', { granularity: 'grapheme' })
  return Array.from(segmenter.segment(filename)).length
}

export const HTTP_URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/

export class ExtendedDateFnsUtils extends DateFnsUtils {
  getCalendarHeaderText(date) {
    return fnsFormat(date, 'yyyy年 MMM', { locale: ja })
  }

  getDatePickerHeaderText(date) {
    return fnsFormat(date, 'MMM d日', { locale: ja })
  }

  getDateTimePickerHeaderText(date) {
    return fnsFormat(date, 'MMM d日', { locale: ja })
  }
}
